import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    exemptionData: [],
    tableLoading: false,
    viewContainerLoading: false,
    showViewContainer: false,
    searchQuery: "",
    currentPage: 1,
    perPage: 5,
    exemptionTotal: 0,
    currentExemption: {},
    employees: [],
    branches: [],
    filterValue: null,
    filterDate: null,
    approvalsData: [],
    approvalData: [],
    currentApproval: {},
    employeeGrades: [],
    departments: [],
    exemptionApprovalTotal: null,
  },
  actions,
  mutations,
};
